import script from "./GeneSnvCount.vue?vue&type=script&lang=js"
export * from "./GeneSnvCount.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__